import { render, staticRenderFns } from "./ProfileDropdown.vue?vue&type=template&id=4f605246&"
import script from "./ProfileDropdown.vue?vue&type=script&lang=js&"
export * from "./ProfileDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports